import React from "react";
import styled from 'styled-components';
import {
    Container, Row, Col,
  } from 'react-bootstrap';
import './Banner-Style.css';
import '../../Style/typo.css';


function BannerPrivateCloud() {
  
    return (
      <div class="banner">
      <Container className='main-body'>
        <Row>
          
            <div class="banner-content-header">
              <div class="text-description-header">
                  <p class="text-header typo-32 typo-medium typo-white">Private Kubernetes</p>
                </div>
                <div class="text-description typo-white">
                  <p class="text-1 typo-21">글로벌 클라우드 종속 없이,&nbsp;</p>
                  <p class="text-2 typo-21">자체 인프라에 Kubernetes 클러스터 구축</p>
                </div>
              </div>
            <div class="banner-intro">
              <div class="banner-intro-text typo-white">
                <p class="typo-14">복잡한 트래픽/리소스 기반 과금 모델, 예측 불가능한 클라우드 비용에 의존하지 않고 기업 내부 자원 위에 독립적인 Kubernetes 환경을 구성할 수 있습니다.</p>
                <p class="typo-14">클라우드 네이티브 인프라의 유연성을 유지하면서도, 비용 제어와 보안 통제가 필요한 환경에 최적화된 대안입니다.</p>
              </div>
            </div>
        </Row>
      </Container>
      </div>

        
    );
};

const TypographyCard = styled.div`
  color: white;
  
  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 10px;
  }
`;


export default BannerPrivateCloud;



